module.exports = __webpack_public_path__ + "img/2.c3a7cfb9.jpg";